import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InventoryState, AdjustmentPayload } from "src/types/inventory.types";

const initialState: InventoryState = {
  transactions: { loading: false, data: null, error: null },
  adjustments: { loading: false, data: null, error: null },
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    // 📊 Get Inventory Transactions
    getTransactionListRequest: (
      state,
      _action: PayloadAction<{
        page?: number;
        limit?: number;
      }>
    ) => {
      state.transactions.loading = true;
      state.transactions.error = null;
    },
    getTransactionListSuccess: (state, action: PayloadAction<any>) => {
      state.transactions.loading = false;
      state.transactions.data = action.payload;
    },
    getTransactionListError: (state, action: PayloadAction<string>) => {
      state.transactions.loading = false;
      state.transactions.error = action.payload;
    },
    resetTransactionList: (state) => {
      state.transactions = { loading: false, data: null, error: null };
    },

    // ⚙️ Create Adjustment Order
    createAdjustmentRequest: (
      state,
      _action: PayloadAction<AdjustmentPayload>
    ) => {
      state.adjustments.loading = true;
      state.adjustments.error = null;
    },
    createAdjustmentSuccess: (state, action: PayloadAction<any>) => {
      state.adjustments.loading = false;
      state.adjustments.data = action.payload;
    },
    createAdjustmentError: (state, action: PayloadAction<string>) => {
      state.adjustments.loading = false;
      state.adjustments.error = action.payload;
    },
    resetAdjustment: (state) => {
      state.adjustments = { loading: false, data: null, error: null };
    },
  },
});

export const {
  getTransactionListRequest,
  getTransactionListSuccess,
  getTransactionListError,
  resetTransactionList,
  createAdjustmentRequest,
  createAdjustmentSuccess,
  createAdjustmentError,
  resetAdjustment,
} = inventorySlice.actions;

export default inventorySlice.reducer;
